<template>
    <div class="page bg-blue relative desktop-footer">
        <div class="bg-head-coin sm:block"></div>
        <div class="page-content sm:px-8">
            <TopBar title="Home" :isShowOnlyLogo="true" :modalController="modalController"></TopBar>
            <MenuDesktop activeMenu="home"></MenuDesktop>
            <div class="px-2 mt-7">
                <LoginMobile :modalController="modalController"></LoginMobile>
            </div>
            <div class="bg-white px-5 mx-2 sm:py-6 mt-4 rounded-25 min-h-607px">
                <div class="pb-4">
                    <div v-if="isShow">
                        <InsuranceExpire />
                    </div>

                    <div class="mb-6 pt-5">
                        <DashboardSlider :apiConfig="dashboardHomeConfig"></DashboardSlider>
                    </div>
                    <div>
                        <FlashDealSlider
                            ref="campaign-list-flashdeal"
                            :initListConfig="listFlashdealConfig"
                            :initFilterConfig="filterFlashdealConfig"
                            :modalController="modalController">
                        </FlashDealSlider>
                    </div>
                    <div class="text-tc-gray-3 text-24 mb-4 pt-4">{{lbl.home.privildges_foryou}}</div>
                    <CampaignList
                            ref="campaign-list"
                            :initListConfig="listConfig"
                            :initFilterConfig="filterConfig"
                            :modalController="modalController"
                    ></CampaignList>
                    <div class="mt-24">
                        <div class="width-menu mx-2 fixed left-0 bottom-0 bg-white pb-4 px-2 rounded-b-25">
                            <MenuMobile activeMenu="home" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <BottomBar></BottomBar>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
//helper
import ConfigManager from '@/config/ConfigManager.js';
import LocationHelper from '@/helper/LocationHelper';
import CacheHelper from '@/helper/CacheHelper';

//component
import TopBar from '@/components/Layout/TopBar/TopBar.vue';
import MenuDesktop from '@/components/Layout/MenuDesktop/MenuDesktop.vue';
import MenuMobile from '@/components/Layout/MenuMobile/MenuMobile.vue';
import DashboardSlider from '@/components/Dashboard/DashboardSlider.vue';
import CampaignList from '../component/CampaignList/CampaignList.vue';
import BottomBar from '@/components/Layout/BottomBar/BottomBar.vue';
import InsuranceExpire from '@/module/Home/component/InsuranceExpire.vue'
import LoginMobile from '@/components/Layout/LoginMobile/LoginMobile.vue';
import FlashDealSlider from '../component/FlashDealSlider.vue';
//service
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder
} from "@/core/Campaign/config/CampaignConfigModel.js";
//mixin
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: 'Home',
    mixins: [ModalMixin, LocaleMixin],
    inject: ["AccountStore"],
    components: {
        TopBar,
        MenuDesktop,
        DashboardSlider,
        CampaignList,
        BottomBar,
        InsuranceExpire,
        MenuMobile,
        LoginMobile,
        FlashDealSlider,
    },
    data: function() {
        return {
            dashboardHomeConfig: ConfigManager.getDashboardHomePage(),
            canpaignListConfig: ConfigManager.getCampaignListHomePage(),
            campaignListFlashdealConfig: ConfigManager.getCampaignListFlashdeal(),
            msg: 'สวัสดีตอนเช้า',
            form:{
                firstname: '',
                point: 0,
                profileImageUrl: ''
            },
            isShow: false,
            currentLat: 13.7248934,
            currentLng: 100.4926816,
        };
    },
    created: function() {
        this.setScrollLoadMore();
        this.initialConfig();
        this.initialConfigFlashdeal();
    },
    mounted: async function() {
        if (this.$route.query && this.$route.query?.newregister) {
            let res = await this.AccountStore.methods.deviceResume();
            if (res != null) {
                this.$router.push('/home')
            }
        }
        this.modalController.loadingModal.show()
        await this.getCurrentLocation();
        this.setCacheLatLng();
        if(this.$route.query && this.$route.query.target_page){
            this.$router.push('/' + this.$route.query.target_page);
        }
        // กลับจาก privilege2.0 ไปหน้า history ต่อ
        if(this.$route.query && this.$route.query.history_page){
            this.$router.replace('/' + this.$route.query.history_page);
        }
        this.AccountStore.methods.apiUpdatePoint();
        this.modalController.loadingModal.hide();
    },
    methods: {
        getCurrentLocation: function() {
            return new Promise((resolve) => {
                LocationHelper.getCurrentLocation().then((location) => {
                    this.currentLat = location.lat;
                    this.currentLng = location.lng
                    resolve();
                }).catch((err) => {
                    console.log(err);
                    console.log(location);
                    // 13.7248934,100.4926816 bangkok
                    this.currentLat = 13.7248934;
                    this.currentLng = 100.4926816;
                    resolve();
                });
            });
        },
         setCacheLatLng: function() {
            let cache = new CacheHelper('session');
            let data = {
                latitude: this.currentLat,
                longitude: this.currentLng
            }
            cache.setCache('info', data);
        },
        initialConfig: function() {
            var configStr = this.canpaignListConfig;
            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(configStr)
                .setTop(25)
                .create();
            this.listConfig = listConfig;

            var filterConfig = new CampaignListFilterConfigBuilder().create();
            this.filterConfig = filterConfig;
        },
        initialConfigFlashdeal: function() {
            var configStr = this.campaignListFlashdealConfig;
            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(configStr)
                .setTop(25)
                .create();
            this.listFlashdealConfig = listConfig;

            var filterConfig = new CampaignListFilterConfigBuilder().create();
            this.filterFlashdealConfig = filterConfig;
        },
        setScrollLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },
        loadMore: function() {
            if(this.$route.fullPath === '/home' || this.$route.fullPath === '/'){
                this.$refs['campaign-list'].loadMore();
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.width-menu {
    width: calc(100% - 16px);
}
</style>
